export const getDisplayName = name => {
  const parts = name.split('#');
  if (parts.length >= 1) {
    return parts[0];
  }
  return name;
};
export const getReferralCode = name => {
  const parts = name.split('#');
  if (parts.length >= 2) {
    return parts[1];
  }
  return name;
};
